// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  WORKER_CONFIG_UPDATE_LOCAL_WORKER_ROLE_FREQUENCY,
} from './constants';

export function updateLocalWorkerRoleFrequency(data) {
  return {
    type: WORKER_CONFIG_UPDATE_LOCAL_WORKER_ROLE_FREQUENCY,
    data
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case WORKER_CONFIG_UPDATE_LOCAL_WORKER_ROLE_FREQUENCY:
      return {
        ...state,
         numChanges: state.numChanges ? state.numChanges + 1 : 1,
         workerRoleFrequencies:
        {
          ...state.workerRoleFrequencies,
          [action.data.id]: action.data
        }
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/worker-config/redux/updateLocalWorkerRoleFrequency.js